import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import io from 'socket.io-client';
import { SocketContext } from './SocketContext';
import { constants } from '../constants';
import AuthActions from './stores/loadz/redux/Auth/actions';

/** Session invalid paths from Socket.IO authenticate (mirror server AUTH_ERROR_CODES). */
const SOCKET_AUTH_REQUIRE_LOGOUT = new Set([
  'TOKEN_EXPIRED',
  'TOKEN_MISSING',
  'TOKEN_INVALID',
  'PAYLOAD_INVALID',
]);

export const SocketProvider = ({ children }) => {
  const dispatch = useDispatch();
  const [socketInstance, setSocketInstance] = useState(null);
  const [isConnected, setIsConnected] = useState(false);

  useEffect(() => {
    const _io = io(constants.URLSOCKET, {
      transports: ['websocket'],
      /** Alineado con el Dashboard histórico (antes de 07e08a750): cookies/credenciales en cross-site */
      withCredentials: true,
    });

    const emitAuth = () => {
      const token = window.localStorage.getItem('token');
      if (!token) {
        console.warn('socket::: no token — authenticate skipped until login');
        return;
      }
      _io.emit('authenticate', token);
      _io.emit('authenticate_bol', token);
    };

    _io.on('connect', () => {
      setIsConnected(true);
      console.log('socket::: connected');
      emitAuth();
    });

    _io.on('disconnect', () => {
      setIsConnected(false);
    });

    const onAuthenticateError = ({ code, message }) => {
      console.warn('socket::: authenticate_error:', code, message);
      if (code && SOCKET_AUTH_REQUIRE_LOGOUT.has(code)) {
        dispatch(AuthActions.logout());
      }
    };

    const onAuthenticateBolError = ({ code, message }) => {
      console.warn('socket::: authenticate_bol_error:', code, message);
      if (code && SOCKET_AUTH_REQUIRE_LOGOUT.has(code)) {
        dispatch(AuthActions.logout());
      }
    };

    _io.on('authenticate_error', onAuthenticateError);
    _io.on('authenticate_bol_error', onAuthenticateBolError);

    setSocketInstance(_io);

    return () => {
      _io.off('connect');
      _io.off('disconnect');
      _io.off('authenticate_error', onAuthenticateError);
      _io.off('authenticate_bol_error', onAuthenticateBolError);
      _io.disconnect();
      setIsConnected(false);
      setSocketInstance(null);
      console.log('socket::: disconnect');
    };
  }, [dispatch]);

  return (
    <SocketContext.Provider value={{ socket: socketInstance, isConnected }}>
      {children}
    </SocketContext.Provider>
  );
};
